export function forkIdFromSearch(search: string): string | null {
  const id = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('fork');
  const trimmed = (id || '').trim();
  return trimmed || null;
}

export function guestForkPaths(currentPath: string): { register: string; login: string } {
  const next = currentPath.startsWith('/') ? currentPath : '/studio';
  const q = encodeURIComponent(next);
  return {
    register: `/register?next=${q}`,
    login: `/login?next=${q}`,
  };
}

export function guestStudioForkRedirect(search: string, pathname = '/studio'): string | null {
  if (!forkIdFromSearch(search)) return null;
  const query = search.startsWith('?') || search === '' ? search : `?${search}`;
  return guestForkPaths(`${pathname}${query}`).register;
}
